import { get } from "lib/fetch";
export const GET_TEMPLATES = "templates/GET_TEMPLATES";

export const getTemplates = () => ({
  type: GET_TEMPLATES,
  payload: get("/v1/ruleseditor/templates"),
});
